import { render, staticRenderFns } from "./PrivacyPolicyContent.vue?vue&type=template&id=c3cf701a&scoped=true"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyContent.vue?vue&type=style&index=0&id=c3cf701a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cf701a",
  null
  
)

export default component.exports